export default __webpack_public_path__ + "static/media/facebook.b869132c.svg";